// ส่ง event เข้า Google Tag Manager (container GTM-TTD7VF5M ฝังอยู่ใน src/template.html)
// เรียกได้ทันทีแม้ gtm.js ยังโหลดไม่เสร็จ เพราะ window.dataLayer เป็นคิว — GTM อ่านย้อนหลังตอนโหลดเสร็จ
// ฝั่ง GTM: สร้าง Trigger แบบ Custom Event ให้ตรงกับชื่อ event แล้วผูกกับ GA4 Event tag
//
// event ที่ใช้ใน sell flow:
//   confirm_appointment  = กดยืนยันนัดหมายผ่านบนหน้าปฏิทิน (ปุ่ม "ทำการนัดหมาย" ผ่าน validation แล้ว)
//   confirm_information  = กดปุ่ม "ยืนยัน" บนหน้าสรุปรายการ (ก่อนยิง booking API)
//   thank_you            = เปิดหน้า Thank you หลังจองสำเร็จ (ยิงครั้งเดียวต่อ 1 booking)
export const pushDataLayer = (event, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (error) {
    // tracking ต้องไม่ทำให้ flow ของลูกค้าพัง
    console.warn('[gtm] push failed', error);
  }
};
